import {
  SavedItemViewModel,
  SavedItemType
} from '../../model/saveditems/types';
import { SavedTrendingTopic } from '../content/types';
import { ApiError } from '../../api/types';

export const ERROR_SAVING_USER_ITEMS = 'ERROR_SAVING_USER_ITEMS';
export const LOADING_USER_SAVED_ITEMS = 'LOADING_USER_SAVED_ITEMS';
export const LOADED_USER_SAVED_ITEMS = 'LOADED_USER_SAVED_ITEMS';
export const ADDING_SAVED_TOPIC = 'ADDING_SAVED_TOPIC';
export const ADDED_SAVED_TOPIC = 'ADDED_SAVED_TOPIC';
export const DELETING_SAVED_ITEMS = 'DELETING_SAVED_ITEMS';
export const DELETED_SAVED_ITEMS = 'DELTED_SAVED_ITEMS';

export type SavedItemActionUpdates = SavedItemCollection & {
  type: SavedItemType;
};

export interface ErrorUserSaveItemsAction {
  type: typeof ERROR_SAVING_USER_ITEMS;
  payload: ApiError;
}

export interface LoadingUserSavedItemsAction {
  type: typeof LOADING_USER_SAVED_ITEMS;
  payload: undefined;
}

export interface LoadedUserSavedItemsAction {
  type: typeof LOADED_USER_SAVED_ITEMS;
  payload: SavedItemState;
}

export interface DeletingItemsAction {
  type: typeof DELETING_SAVED_ITEMS;
  payload: SavedItemType;
}

export interface DeletedItemsAction {
  type: typeof DELETED_SAVED_ITEMS;
  payload: SavedItemActionUpdates;
}
export interface AddingSavedTopicAction {
  type: typeof ADDING_SAVED_TOPIC;
  payload: undefined;
}

export interface AddedSavedTopicAction {
  type: typeof ADDED_SAVED_TOPIC;
  payload: SavedItemViewModel;
}

export type SavedItemActionTypes =
  | LoadingUserSavedItemsAction
  | LoadedUserSavedItemsAction
  | DeletingItemsAction
  | DeletedItemsAction
  | AddedSavedTopicAction
  | AddingSavedTopicAction
  | ErrorUserSaveItemsAction
  | SavedTrendingTopic;

export interface SavedItemCollection {
  updating: boolean;
  items: SavedItemViewModel[];
}

export enum SavedItemLoadingStatus {
  Uninitialized,
  Loading,
  Loaded,
  Error
}

type ItemTypeLookup = {
  [k in keyof typeof SavedItemType]: SavedItemCollection;
};

export interface SavedItemState {
  status: SavedItemLoadingStatus;
  items: ItemTypeLookup;
}
